import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { Home, Camera, History as HistoryIcon, Settings, AlertTriangle, User, Moon, Sun, ShieldPlus, Book, Gamepad2 } from 'lucide-react';
import WebcamFeed from './components/WebcamFeed';
import Dashboard from './components/Dashboard';
import Instructions from './components/Instructions';
import History from './components/History';
import Profile from './components/Profile';
import Practice from './components/Practice';
import './index.css';

const Sidebar = () => {
  const location = useLocation();
  const navItems = [
    { path: '/', label: 'Dashboard', icon: <Home size={20} /> },
    { path: '/translate', label: 'Translate', icon: <Camera size={20} /> },
    { path: '/practice', label: 'Practice', icon: <Gamepad2 size={20} /> },
    { path: '/guide', label: 'Sign Guide', icon: <Book size={20} /> },
    { path: '/history', label: 'History', icon: <HistoryIcon size={20} /> },
    { path: '/emergency', label: 'Emergency', icon: <AlertTriangle size={20} color="#ef4444" /> },
    { path: '/settings', label: 'Settings', icon: <Settings size={20} /> },
    { path: '/profile', label: 'Profile', icon: <User size={20} /> },
  ];

  return (
    <aside className="sidebar">
      <Link to="/" className="sidebar-logo">
        <ShieldPlus size={28} color="#4F46E5" />
        <span>SignAI</span>
      </Link>
      
      <nav className="sidebar-nav">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
          >
            {item.icon}
            <span>{item.label}</span>
          </Link>
        ))}
      </nav>
      
      <div style={{ marginTop: 'auto', padding: '16px', fontSize: '12px', color: 'var(--text-muted)' }}>
        <span>Enterprise v2.0</span>
      </div>
    </aside>
  );
};

const App = () => {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved ? saved === 'dark' : window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.body.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [darkMode]);

  return (
    <Router>
      <div className="app-container">
        <Sidebar />
        
        <main className="main-content">
          <header className="top-header">
            <div>
              <h2 style={{ margin: 0 }}>Welcome back, Interpreter</h2>
              <p style={{ margin: '4px 0 0', color: 'var(--text-muted)' }}>Ready for live translation</p>
            </div>
            
            <button className="theme-toggle" onClick={() => setDarkMode(!darkMode)} aria-label="Toggle Theme">
              {darkMode ? <Sun size={20} /> : <Moon size={20} />}
            </button>
          </header>

          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/translate" element={<WebcamFeed />} />
            <Route path="/practice" element={<Practice />} />
            <Route path="/guide" element={<Instructions />} />
            <Route path="/history" element={<History />} />
            <Route path="/emergency" element={<div className="glass-panel"><h2>Emergency Mode</h2><p>One-click emergency phrases coming soon.</p></div>} />
            <Route path="/settings" element={<div className="glass-panel"><h2>System Settings</h2><p>Settings coming soon.</p></div>} />
            <Route path="/profile" element={<Profile />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
};

export default App;
